import { graphql } from "react-relay";
import "@components/data-source/DataSource.gql";
import "@components/data-source-create/DataSourceCreate.gql";

export const fragments = {
  org: graphql`
    fragment OnboardingPrivateCalendarSyncStep_org on Org {
      id
      domains
      ...DataSource_org
      ...DataSourceCreate_org
    }
  `,
  user: graphql`
    fragment OnboardingPrivateCalendarSyncStep_user on User {
      id
      dataSources(first: 1000000) {
        edges {
          node {
            id
            state
            type
            name
            ...DataSource_dataSource
          }
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query OnboardingPrivateCalendarSyncStepQuery($userId: ID!, $orgId: ID!) {
    org: node(id: $orgId) {
      ... on Org {
        ...OnboardingPrivateCalendarSyncStep_org
      }
    }

    user: node(id: $userId) {
      ... on User {
        ...OnboardingPrivateCalendarSyncStep_user
      }
    }
  }
`;
